{
  "version": 1,
  "asset_id": "4c84e894-946d-4305-8f80-ea29bd666480",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/4c84e894-946d-4305-8f80-ea29bd666480/battery-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/4c84e894-946d-4305-8f80-ea29bd666480/battery-hero.webp",
  "original_filename": "battery-hero.webp",
  "size": 39830,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:24:44Z"
}
